import $ from 'jquery';

async function fadeOutAsync(selector) {
  return new Promise((resolve) => {
    $(selector).fadeOut(resolve);
  });
}

export default fadeOutAsync;
